import {
  CLASS_HIDE,
  CLASS_SELECTED,
  FilterId
} from '../const';
import {
  Search
} from './search';
import {
  Clones
} from './clones';
import {
  Subs
} from './subs';
export class Filter {

  constructor(elem) {
    this._elem = elem;
    this._id = elem.dataset.id;
    this._title = elem.querySelector('.block-filter__title');
    this._container = elem.querySelector('.block-filter__container');
    this._wrapper = elem.querySelector('.block-filter__wrapper');
    this._wrapperId = this._wrapper.id;
    this._list = elem.querySelector('.block-filter__list');
    this._clones = new Clones(this._elem);
    this._subs = (this._id === FilterId.CLOTHES || this._id === FilterId.HATS || this._id === FilterId.SHOES) ? new Subs(this._elem) : null;
    this._searchList = this._subs ? this._subs.getList() : this._list;
    this._searchContainer = elem.querySelector('.block-filter__search');
    this._search = this._searchContainer ? new Search(this._searchContainer, this._subs ? 'subs' : 'list') : null;
    this._stash = '';

    this._resetSearchClickHandler = this._resetSearchClickHandler.bind(this);

    if (this._search) {
      this._search.setClickHandler(this._resetSearchClickHandler);
    }

    if (this._subs) {
      this._container.classList.add('hide');
    }
  }

  getElem() {
    return this._elem;
  }

  getId() {
    return this._id;
  }

  getWrapperId() {
    return this._wrapperId;
  }

  getCheckedInputs() {
    const inputs = this.getInputs();
    return Array.from(inputs).filter(input => input.checked);
  }

  getCheckedInput() {
    const inputs = this.getInputs();
    return Array.from(inputs).find(input => input.checked);
  }

  setClickHandler(callback) {
    this._callbackUpdate = callback;
  }

  checkInputByValue(value) {
    const inputs = this.getInputs();
    const input = Array.from(inputs).find(inp => inp.value === String(value));
    input.checked = true;
  }

  getUrlWithParam(name, value) {
    const type = this.getWrapperId().includes('characteristics') ? 'characteristics' : 'd_attributes';
    const url = new URL(window.location.href);

    url.searchParams.append(`${type}[${name}][]`, value);
    return url.href;
  }

  distributeClickHandler(elem) {
    if (this._isReset(elem)) {
      this.reset();
      this._callbackUpdate();

    } else if (this._isTitle(elem)) {
      this.toggle();

    } else if (this._isCloneElem(elem)) {
      const item = this._isCloneElem(elem);
      this._clones.remove(item);
      this._findAndResetInput(item);
      this._callbackUpdate();

    } else if (this._isSubElem(elem)) {
      const item = this._isSubElem(elem);
      this._subs.active(item);
      this._callbackUpdate();
    }
  }

  setCount(count) {
    const container = this._title.querySelector('.block-filter__count');

    if (count > 0) {
      container.classList.remove('hide');
      container.textContent = ': ' + count;
    } else {
      container.classList.add('hide');
      container.textContent = '';
    }
  }

  reset() {
    const inputs = this.getInputs();
    Array.from(inputs).forEach((input) => (input.checked = false));
    if (this._search) {
      this._search.clear();
    }
    if (this._subs) {
      this._subs.removeParam();
    }
    this._clones.removeAll();

    this._elem.classList.remove('block-filter--selected');
  }

  toggle() {
    if (this._isActiveElem(this._elem)) {
      this._elem.classList.remove('active');
    } else {
      this._elem.classList.add('active');
    }
  }

  hide() {
    this._elem.classList.remove('active');
  }

  update(selectFilters, enabledFilters, cls) {

    if (selectFilters.has(this._wrapperId)) {
      this._elem.classList.remove(cls);
      this._elem.classList.add('block-filter--selected');
      this._title.classList.add(CLASS_SELECTED);
      this._title.classList.remove(cls);
      this._wrapper.classList.remove(cls);

    } else if (enabledFilters.has(this._wrapperId)) {
      this._elem.classList.remove(cls);
      this._elem.classList.remove('block-filter--selected');
      this._title.classList.remove(CLASS_SELECTED);
      this._title.classList.remove(cls);
      this._wrapper.classList.remove(cls);

    } else {
      this._elem.classList.add(cls);
      this._elem.classList.remove('block-filter--selected');
      this._title.classList.remove(CLASS_SELECTED);
      this._title.classList.add(cls);
      this._wrapper.classList.add(cls);
    }

    if (!this._subs) {

      const count = this.getCheckedInputs().length;
      this.setCount(count);
    }


  }

  updateTitle() {
    const subtitles = this._list.querySelectorAll('.block-filter__subtitle');
    subtitles.forEach(subtitle => {
      const id = subtitle.dataset.parentId;
      const subcategoryes = this._list.querySelectorAll(`.block-filter__item--${id}`);
      const isAllHide = Array.from(subcategoryes).every(subcategory => subcategory.classList.contains('uf_hide'));
      return isAllHide ? subtitle.classList.add('uf_hide') : subtitle.classList.remove('uf_hide');
    });
  }

  stashClones(checkbox) {
    const html = this._getCloneElemHtml(checkbox);
    this._stash += html;
  }

  applyStash() {
    this._clones.add(this._stash);
  }

  clearStash() {
    this._stash = '';
  }

  search() {
    this._search.search(this._searchList);
  }

  clearSearch() {
    if (this._search) {
      this._search.clear();
    }
  }

  updateSubs() {
    if (this._subs) {
      this._subs.init();

      const count = this._subs.getCount();
      this.setCount(count);
    }
  }

  getInputs() {
    return this._elem.querySelectorAll('input[type=checkbox]');
  }

  _resetSearchClickHandler() {
    this._search.clear();
    this._search.search(this._searchList);
  }

  _getCloneElemHtml(elem) {
    const text = elem.nextElementSibling.textContent;
    return '<li class="block-filter__clone" data-id=\"' + elem.id + '\"><span class="control__clone">' + text + '</span></li>';
  }

  _findAndResetInput(item) {
    const id = item.dataset.id;
    const input = this._list.querySelector(`#${id}`);
    this._resetInput(input);
  }

  _resetInput(input) {
    input.checked = false;
    input.closest('.block-filter__item').classList.remove(CLASS_HIDE);
  }

  _isActiveElem(elem) {
    return elem.classList.contains('active');
  }

  _isReset(elem) {
    return elem.closest('.block-filter__reset');
  }

  _isTitle(elem) {
    return elem.closest('.block-filter__title');
  }

  _isCloneElem(elem) {
    return elem.closest('.block-filter__clone');
  }

  _isSubElem(elem) {
    return elem.closest('.sub-filter__item');
  }
}
